import React, { useEffect, useState } from 'react'
import InputField from '../../../CommonComponents/InputMUI'

const AddEventPopup = ({ actionHandler}) => {
    const [name , setName] = useState("")

    const inputChange=(e)=>{
        setName(e)
    }
    useEffect(()=>{
        document.getElementById("name").focus();

    },[])

    return (
        <div className="background-blur-external" style={{ zIndex: '9999' }}>
            <div className='delete-popup-main'>
            <div className="background-blur-external" style={{ zIndex: '9999' }}>
            <div className='delete-popup-main'>
                <h4 className='mb-3'>Add Task</h4>
                <div className='mt-3 row'>
                    <div className='mb-3 col-sm-12'>
                        <InputField
                            label="Name"
                            variant="outlined"
                            value={name}
                            name="name"
                            id="name"
                            type="text"
                            required={true}
                            onChange={e => inputChange(e)}
                            size="small" />
                    </div>
                </div>
                <div className="text-center">
                    <button type="button" className="cred-btn" onClick={e => actionHandler("", 'close')}>Cancel</button>
                    <button type="button" className="cred-btn cancel-btn" onClick={e => actionHandler(name, "save")}>Add</button>
                </div>
            </div>
          
        </div>
               
            </div>
        </div>
    )
}

export default AddEventPopup;